import { Col, Container, Nav, Row } from "react-bootstrap";
import NavLink from "../Navigation/NavLink";

import footerMenu from "./footerMenu.json";

const currentYear = new Date().getFullYear();

const Footer = () => (
	<Container
		as="footer"
		className="bg-blue px-3 py-4 py-md-2 align-items-center justify-content-between"
		fluid
		id="main-footer"
		style={{ marginBottom: "70px" }}
	>
		<Row>
			<Col className="text-white fs-14 text-center text-lg-start" lg={5} md={12}>
				Copyright © 2001-{currentYear} Life With Cancer™. All rights reserved.
			</Col>

			<Col lg={7} md={12}>
				<Nav className="d-block text-center text-md-end">
					{footerMenu.map((item) => (
						<Nav.Item className="d-sm-block d-md-inline-block" key={item.slug}>
							<NavLink className="fs-14 text-neutral10" href={item.href} to={item.to}>
								{item.name}
							</NavLink>
						</Nav.Item>
					))}
				</Nav>
			</Col>
		</Row>
	</Container>
);

export default Footer;
